import { X, Loader2 } from "lucide-react";

export const QuoteRequestsPanel = ({ requests, toggleRequests }) => {
  if (!requests.open) return null;
  return (
    <div className="card card-padded mb-4" data-testid="quote-requests-panel">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[11px] font-bold uppercase tracking-wider" style={{ color: "var(--green-700)" }}>
          Detected email quote requests
        </div>
        <button onClick={toggleRequests} className="text-slate-400 hover:text-slate-600" data-testid="quote-requests-close">
          <X size={14} />
        </button>
      </div>
      {requests.entries === null ? (
        <div className="flex items-center gap-2 text-sm muted py-2"><Loader2 size={13} className="animate-spin" /> Loading…</div>
      ) : requests.entries.length === 0 ? (
        <p className="text-sm muted py-1">No emails scanned yet — inboxes are checked every 10 minutes, or use "Scan inbox".</p>
      ) : (
        <div className="divide-y divide-slate-50 max-h-64 overflow-y-auto">
          {requests.entries.map((e) => (
            <div key={e.message_id} className="py-2 flex items-start justify-between gap-3 text-sm" data-testid={`quote-request-${e.message_id}`}>
              <div className="min-w-0">
                <div className="font-medium truncate">{e.subject || "(no subject)"}</div>
                <div className="text-xs muted truncate">
                  from {e.from} → {e.account} · {new Date(e.processed_at).toLocaleString()}
                  {e.acknowledged && <span className="text-emerald-700"> · auto-acknowledged ✓</span>}
                </div>
              </div>
              {String(e.outcome || "").startsWith("created") ? (
                <span className="text-xs font-bold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 shrink-0">
                  {e.outcome.replace("created ", "→ ")}
                </span>
              ) : (
                <span className="text-xs px-2 py-0.5 rounded-full bg-slate-100 text-slate-500 shrink-0">not a request</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
